import { render } from "./insure-team-report-add.vue?vue&type=template&id=338676f6&scoped=true&ts=true"
import script from "./insure-team-report-add.vue?vue&type=script&lang=ts"
export * from "./insure-team-report-add.vue?vue&type=script&lang=ts"

import "./insure-team-report-add.vue?vue&type=style&index=0&id=338676f6&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338676f6"]])

export default __exports__